<script setup lang="ts">
import type { EventStoryblok, Story } from '@/types'

interface Props {
  events: Story<EventStoryblok>[]
}

const props = defineProps<Props>()

const featuredEvents = computed(() =>
  props.events.filter((event) => {
    return event.content?.is_featured
  }),
)

const upcomingEvents = computed(() => {
  return props.events.filter((event) => {
    return !event.content?.is_featured
  })
})
</script>

<template>
  <section id="event-lists" class="event-page-lists flow">
    <div v-if="featuredEvents.length" class="container">
      <h5 class="event-page-lists__heading">
        {{ $t('common.events.featured_events') }}
      </h5>
      <section class="event-page-lists__list">
        <EventCard
          v-for="event in featuredEvents"
          :key="event.id"
          :event-slug="event.slug"
          :event="event.content"
        />
      </section>
    </div>
    <div v-if="upcomingEvents.length" class="container">
      <h5 class="event-page-lists__heading">
        {{ $t('common.events.upcoming_events') }}
      </h5>
      <section class="event-page-lists__list">
        <EventCard
          v-for="event in upcomingEvents"
          :key="event.id"
          :event-slug="event.slug"
          :event="event.content"
        />
      </section>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.event-page-lists {
  padding: 80px 0;

  --space: 80px;

  @media (min-width: $breakpoint-lg) {
    padding: 128px 0;

    --space: 128px;
  }

  &__heading {
    @include heading-3;

    margin-bottom: 48px;

    @media (min-width: $breakpoint-lg) {
      @include heading-2;

      margin-bottom: 56px;
    }
  }

  &__list {
    display: flex;
    gap: 24px;
    flex-direction: column;
  }
}
</style>
